import src from "IMAGE";
export default { src, width: 111, height: 113, blurWidth: 0, blurHeight: 0};
